module.exports = __webpack_public_path__ + "static/media/send.0198f7c2.svg";